import { useQuery } from "@tanstack/react-query";
import { GlobalActionsConfigRepository } from "../../domain/interfaces/GlobalActionsConfigRepository";
import { GlobalActionsConfigEntity } from "../../domain/globalActionConfig.entity";
import { globalActionsQueryKeys } from "../../infrastructure/cache/GlobalActionsCacheStrategy";

interface UseGlobalActionsConfigsOptions {
  enabled?: boolean;
}

export function useGlobalActionsConfigs(
  propertyTicker: string,
  repository: GlobalActionsConfigRepository,
  { enabled = true }: UseGlobalActionsConfigsOptions = {}
) {
  return useQuery({
    queryKey: globalActionsQueryKeys.list(propertyTicker),
    queryFn: (): Promise<GlobalActionsConfigEntity[]> => repository.findByProperty(propertyTicker),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
